import React, { useEffect } from "react";
import _ from 'underscore';
import moment from 'moment';
import { Form, Modal, Button, message, DatePicker, Checkbox, Select, Typography } from 'antd';
import sortOrder from './utils/sortOrder';
import filter from './utils/filter';

import FindCostObject from '../Schedule/SelectCostObject/FindCostObject';

const { Option } = Select;
const { Text } = Typography;

const datePickerFormat = 'MMM Do YYYY'
const by = 'costObject';

const ApprovalFindByCostObject = ({ requestDates, showCostObjectModal, costObject, ...props }) => {

  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;

  useEffect(() => { // set form values
    const form = props.form;
    form.setFieldsValue({
      fromDate: requestDates.fromDate ? moment(requestDates.fromDate).startOf('day') : moment().startOf('day'),
      toDate: requestDates.toDate ? moment(requestDates.toDate).startOf('day') : moment().startOf('day'),
    });
  }, [requestDates, costObject]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const validateForm = () => { // validates the whole form
    const form = props.form;

    const fromDate = form.getFieldValue('fromDate') ? form.getFieldValue('fromDate').startOf('day').clone() : null;
    const toDate = form.getFieldValue('toDate') ? form.getFieldValue('toDate').startOf('day').clone() : null;

    let fromDateErrors = [];
    if (!fromDate) {
      fromDateErrors.push(new Error('Please input start date!'));
    }
    if (fromDate && toDate && toDate.isBefore(fromDate)) {
      fromDateErrors.push(new Error('Start date cannot occur after end date!'));
    }
    if (fromDateErrors.length > 0) {
      form.setFields({
        fromDate: {
          value: fromDate,
          errors: fromDateErrors,
        }
      });
    } else {
      form.setFields({
        fromDate: {
          value: fromDate,
        }
      });
    }

    let toDateErrors = [];
    if (!toDate) {
      toDateErrors.push(new Error('Please input end date!'));
    }
    if (toDate && fromDate && fromDate.isAfter(toDate)) {
      toDateErrors.push(new Error('End date cannot occur before start date!'));
    }
    if (toDateErrors.length > 0) {
      form.setFields({
        toDate: {
          value: toDate,
          errors: toDateErrors,
        }
      });
    } else {
      form.setFields({
        toDate: {
          value: toDate,
        }
      });
    }
  }

  const validateCostObject = () => {
    const form = props.form;

    let costObjectErrors = [];
    if (_.isEmpty(costObject)) {
      costObjectErrors.push(new Error('please select a cost object!'))
    }
    if (costObjectErrors.length > 0) {
      form.setFields({
        costObject: {
          value: costObject,
          errors: costObjectErrors,
        }
      });
    } else {
      form.setFields({
        costObject: {
          value: costObject,
        }
      });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    validateForm();
    validateCostObject();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue();
      formValues.costObject = costObject
      console.log('Success! Received values of form: ', formValues)
      props.searchByCostObject(formValues, by);
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

  return (
    <Form
      onSubmit={(e) => handleSubmit(e)}>

      <Form.Item
        label="From Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('fromDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="fromDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleFromDateChange(e, validateForm)}
            allowClear={false}
            placeholder={'Select date and time'}
            format={datePickerFormat}
            size={'large'}
            popupStyle={{ zIndex: 2000 }}
          />
        )}
      </Form.Item>

      <Form.Item
        label="To Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('toDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="toDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleToDateChange(e, validateForm)}
            allowClear={false}
            placeholder={'Select date and time'}
            format={datePickerFormat}
            size={'large'}
            popupStyle={{ zIndex: 2000 }}
            style={{ marginBottom: 15 }}

          />
        )}
      </Form.Item>

      {/* Cost Object */}
      <Form.Item
        label='Cost Object'
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('costObject', {
          rules: [{
            required: true, message: 'Please input a status!',
          }],
        })(
          <Text>
            {costObject && costObject.costObjectName ? costObject.costObjectName : ''}
          </Text>
        )}
      </Form.Item>

      <Button
        className='form-button'
        onClick={props.handleShowCostObjectModalOpen}
        style={{ display: 'block', marginBottom: 15 }}
      >
        Find Cost Object
      </Button>

      <Form.Item
        label='Cost Object Type'
        style={{ display: 'flex', marginBottom: 5 }}
      >
        <Text>
          {costObject && costObject.costObjectType ? costObject.costObjectType : ''}
        </Text>
      </Form.Item>

      <Modal
        visible={showCostObjectModal}
        title={'Find Cost Object'}
        onCancel={props.handleShowCostObjectModalCancel}
        zIndex={3000}
        footer={[
        ]}
      >
        <FindCostObject
          requestDate={moment(requestDates.fromDate).format()}
          handleSelectCostObject={props.handleSelectCostObject}
          handleModalCancel={props.handleShowCostObjectModalCancel}
        />
      </Modal>

      <Form.Item
        label="Filter"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('filter', {
          initialValue: filter[0].value || null,
          rules: [{
            required: true, message: 'Please input a status!',
          }],
        })(
          <Select
            name='filter'
            allowClear={false}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
          >
            {filter.map((filterOption, index) => {
              return <Option key={'filterOption' + index} value={filterOption.value} >{filterOption.name}</Option>
            })}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        label="Sort Order"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('sortOrder', {
          initialValue: sortOrder[0].value || null,
          rules: [{
            required: true, message: 'Please input a sort order!',
          }],
        })(
          <Select
            name='sortOrder'
            allowClear={false}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
          >
            {sortOrder.map((sortOption, index) => {
              return <Option key={'sortOption' + index} value={sortOption.value} >{sortOption.name}</Option>
            })}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 24 }}
      >
        {getFieldDecorator('sortByCostObject', {
          initialValue: false,
        })(
          <Checkbox name='sortByCostObject'>
            Sort By Cost Object
          </Checkbox>
        )}
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType='submit'>
          Submit
        </Button>
      </Form.Item>

    </Form >
  );
}

const WrappedApprovalFindByCostObject = Form.create()(ApprovalFindByCostObject);
export default WrappedApprovalFindByCostObject;



// WEBPACK FOOTER //
// ./src/Components/Approval/ApprovalFindByCostObject.js